// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var PlanAndBillingSettingsController = function ($scope, PlanAndBillingSettings) {
    $scope.settings = PlanAndBillingSettings.get();
};
PlanAndBillingSettingsController.$inject = ['$scope', 'PlanAndBillingSettings'];
